// extracted by mini-css-extract-plugin
module.exports = {"border":"style__border___1iIdt","tooltip":"style__tooltip___2x1za"};